<script>
/**
 * 参照のみを定義するmixin
 */
export default {
	computed:{
		is_login: function(){
			if(this.$store.getters.get_user_id)return true;
			return false;
		},
		user_id: function(){
			return this.$store.getters.get_user_id;
		},
		user_name: function(){
			return this.$store.getters.get_user_name;
		},
		setting_param: function(){
			return this.$store.getters.get_setting_param;
		},
		url_login: function(){
			return "login";
		},
		// url_register: function(){
		// 	return "register";
		// },
		url_logout: function(){
			return "logout";
		},
		csrf_token:function(){
			return this.$store.getters.get_csrf_token;
		},
		check_client:function(){
			return this.$store.getters.get_check_client;
		},
	},
	watch: {
		setting_param : function(){
			// 初期化イベントを発行
			this.onLoadSetting();
		},
	},
	methods : {
		//! 設定パラメータ変更イベント
		onLoadSetting : function(){
			console.log("[ onSettingParamChange ]");
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/vuex/setting/read.mixin.vue